import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dx-header-curve',
  templateUrl: './header-curve.component.html',
  styleUrls: ['./header-curve.component.scss']
})
export class HeaderCurveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
